<div class="mc-table-item">
  <h4 class="mc-table-title">Verisk Maplecroft's Language of Probability</h4>

  <table class="table">
    <thead>
      <tr class="mc-header-row">
        <th class="mc-col-header-cell">Language</th>
        <th class="mc-col-header-cell">Probability</th>
      </tr>
    </thead>
    <tbody>
      <tr class="mc-data-row" *ngFor="let data of lopTableContent">
        <td>
          {{ data.language }}
        </td>
        <td>
          {{ data.probability }}
        </td>
      </tr>
    </tbody>
  </table>

  <span class="attribution"> Source: Verisk Maplecroft </span>
</div>
